import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface IProps {
  children: ReactNode;
  redMine?: boolean;
}

const FormWrapTag = styled.div<IProps>`
  margin-top: ${({ redMine }) => (redMine ? '10px' : '40px')};
  padding: ${({ redMine }) => (redMine ? '0' : '40px 111px')};
  border: ${({ redMine }) => (redMine ? 'none' : '1px solid #dddddd')};

  @media ${({ theme }) => theme.device.tablet} {
    padding: ${({ redMine }) => (redMine ? '0' : '50px 10px 10px 10px')};
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: ${({ redMine }) => (redMine ? '0' : '50px 10px 10px 10px')};
  }
`;

const FormTop = styled.div<IProps>`
  padding: ${({ redMine }) => (redMine ? '30px 50px 40px' : '10px 80px 10px 80px')};
  background-color: #f7f7f7;
  border: ${({ redMine }) => (redMine ? '1px solid #ddd' : 'none')};

  @media ${({ theme }) => theme.device.tablet} {
    padding: ${({ redMine }) => (redMine ? '0' : '10px')};
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: ${({ redMine }) => (redMine ? '0' : '10px')};
  }
`;

const FormBottom = styled.div<IProps>`
  margin: ${({ redMine }) => (redMine ? '40px 0 0' : '0')};
  padding: ${({ redMine }) => (redMine ? '0' : '40px 0')};
`;

const FormBox = styled.div`
  background-color: #f7f7f7;
  padding: 70px 80px;

  @media ${({ theme }) => theme.device.tablet} {
    padding: 10px;
  }
  @media ${({ theme }) => theme.device.mobile} {
    padding: 10px;
  }
`;

function FormWrap(props: IProps) {
  return <FormWrapTag {...props}>{props.children}</FormWrapTag>;
}

FormWrap.Top = FormTop;
FormWrap.Bottom = FormBottom;
FormWrap.Box = FormBox;

export default FormWrap;
